import { useEffect, useState } from 'react';
import { Input } from '@myua/kit';
import '../styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getSearchUploadData, getSimilarAsset } from '../selectors';
import { Options } from './Options';
import { AiToggle } from './AiToggle';
import { FilePicker } from './FilePicker';
import { useIsDragging } from './useIsDragging';
import { useUploader } from './useUploader';
import { useUpdateState } from './useUpdateState';
import { getAllowedTransferItem } from '../model';
import * as searchActions from '../actions';

export const Search = () => {
  const dispatch = useDispatch();
  const uploadData = useSelector(getSearchUploadData);
  const isDragging = useIsDragging();
  const [localFile, setLocalFile] = useState<File | null>(null);
  const { text, updateState } = useUpdateState();
  const similarAsset = useSelector(getSimilarAsset);

  const uploader = useUploader({
    onSuccess: (newUploadData) => {
      setLocalFile(null);
      updateState({ text: '', uploadData: newUploadData });
    },
    onError: () => {
      setLocalFile(null);
      updateState({ text: '', uploadData: undefined });
    },
  });

  useEffect(() => {
    if (similarAsset) {
      setLocalFile(null);
      uploader.abort();
    }
  }, [similarAsset, uploader]);

  const resetSimilar = () =>
    dispatch(searchActions.similarAssetChanged({ similarAsset: undefined }));

  const isFileNameDisplayed = Boolean(localFile || uploadData || similarAsset);
  const inputValue = similarAsset?.name ?? localFile?.name ?? uploadData?.fileName ?? text;

  return (
    <div
      className={`al-search-drop-area ${isDragging ? 'al-search-drop-area_is-dragging' : ''}`}
      onDrop={(event) => {
        const file = getAllowedTransferItem(event.dataTransfer)?.getAsFile();
        if (file) {
          event.preventDefault();
          setLocalFile(file);
          uploader.upload(file);
          resetSimilar();
        }
      }}
    >
      <Input
        className={`al-search ${isFileNameDisplayed ? 'al-search_with-file-name' : ''}`}
        placeholder="Search..."
        value={inputValue}
        onChange={(e) => {
          if (isFileNameDisplayed) {
            if (!e.target.value) {
              // нажали на крестик
              setLocalFile(null);
              uploader.abort();
              resetSimilar();
              updateState({ text: e.target.value, uploadData: undefined });
            }
            // запрещаем ввод текста
            return;
          }
          updateState({ text: e.target.value, uploadData: undefined, debounce: true });
        }}
        allowClear
        suffix={
          <>
            <AiToggle disabled={isFileNameDisplayed} />
            <Options disabled={isFileNameDisplayed} />
          </>
        }
      />
      <FilePicker
        isActive={isFileNameDisplayed}
        isUploading={uploader.isUploading || Boolean(similarAsset)}
        onChange={(file) => {
          setLocalFile(file);
          uploader.upload(file);
          resetSimilar();
        }}
      />
    </div>
  );
};
